var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcSendPurple(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "20px",
    viewBox: "0 0 24 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "send-inactive") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Customised-Themes",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-chat-conversation-dark-green",
    transform: "translate(-340.000000, -1726.000000)",
    fill: "#9932CC"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-10",
    transform: "translate(-10.000000, 1707.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "send-inactive",
    transform: "translate(350.000000, 19.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Page-1",
    points: "0 0 0 7.77777778 16.6666667 10 0 12.2222222 0 20 23.3333333 10"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcSendPurple);
export default __webpack_public_path__ + "static/media/icSendPurple.a04db5c073fb6b0ee020992f6f44cd6d.svg";
export { ForwardRef as ReactComponent };